import { Pipe, PipeTransform } from '@angular/core';
import { UnitsService } from 'app/shared/services/units/units.service';

@Pipe({
    name: 'smallDecimal',
    standalone: false
})
export class SmallDecimalPipe implements PipeTransform {

  constructor(private unitsService: UnitsService) { }

  decimalSeparator: string = this.unitsService.getDecimalSeparator();

  transform(value: string, classes?: string): string {
    if (value === '-') return value;
    if (value === null || value === undefined) {
      return '';
    }

    const formattedValue = value.toString();

    const parts = formattedValue.split(this.decimalSeparator);

    if (parts.length === 1) {
      return formattedValue;
    }

    const wholePart = parts[0];
    const decimalPart = parts[1];

    // uncomment when 9476 is ready to development
    // return `${wholePart}${this.decimalSeparator}<span class="decimal-small ${classes}">${decimalPart}</span>`;
    return `${wholePart}${this.decimalSeparator}${decimalPart}`;
  }
}